import { skipToken } from '@reduxjs/toolkit/query';
import { useLocation, useParams } from 'react-router-dom';

import type { User } from '@/types';

import { useGetUserQuery } from '@/store/api/userApi';
import { isCoachAppPath } from '@/utils/appContext';

export const useView = () => {
  const location = useLocation();
  const isCoach = isCoachAppPath(location.pathname);
  const isClient = !isCoach;
  const { id: selectedUserId = '' } = useParams();

  const isOverview = isCoach && !!selectedUserId;

  const {
    data: selectedUser = {} as User,
    isError,
    isFetching,
    isLoading,
    refetch: refetchSelectedUser,
  } = useGetUserQuery(selectedUserId || skipToken, {
    skip: !selectedUserId,
  });

  return {
    selectedUserId,
    isClient,
    isCoach,
    isOverview,
    isViewError: !!selectedUserId && isError,
    isViewFetching: !!selectedUserId && isFetching,
    isViewLoading: !!selectedUserId && isLoading,
    refetchSelectedUser,
    selectedUser,
  };
};
